import "./SeoConsultantUk.module.css";
import Header from "@/reusable_sections/Header";
import ConsultantHero from "./sections/ConsultantHero";
import ProcessCoverage from "./sections/ProcessCoverage";
import Directory from "./sections/Directory";
import Footer from "@/reusable_sections/Footer";
export default function SeoConsultantUkPage() {
  return <div>
      <Header />
      <ConsultantHero />
      <ProcessCoverage />
      <Directory />
      <Footer />
    </div>;
}